import Repository from "./Repository";

const resource = "/Supplier";
import store from "../store";
export default {
  get(page, size) {
    return Repository.get(`${resource}/${page}/${size}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  create(supplier) {
    return Repository.post(`${resource}`, supplier)
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSingle(id) {
    return Repository.get(`${resource}/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  update(supplier) {
    return Repository.put(`${resource}`, supplier)
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateMainSupplier() {
    return Repository.get(`${resource}/check-is-main-supplier-exist`)
      .then((response) => {
        if (response.data.status === "success") {
          store.commit("updatemainSupplier", response.data.data);
        }
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSupplierRates(id) {
    return Repository.get(`${resource}/get-supplier-currency-rates/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateSupplierRates(id) {
    return Repository.post(`${resource}/update-supplier-currency-rates/${id}`)
      .then((response) => {
        store.commit("setSnack", {
          message: "Курсы валют были обновлены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateSuppplierPrices(id, categoryIds) {
    return Repository.post(`${resource}/update-price/${id}`, categoryIds)
      .then((response) => {
        store.commit("setSnack", {
          message: "Цены товаров были обновлены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
